var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{staticClass:"emarticon-guide",attrs:{"src":require(`/src/assets/images/${_vm.$route.query.data}.png`),"alt":"이마티콘 자동충전"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }